<template>
    <div>
      <router-view></router-view>
    </div>
</template>
<script>
export default {
  name: 'Solution',
  // beforeRouteEnter (to, from, next) {
  //   next(vm => {
  //     vm.$router.replace({ name: 'Home', params: { source: 'solution' } })
  //   })
  // }
}
</script>

<style>

</style>
